/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeEquityContract} from '../api'

export const useMutationExecuteEquityContract = createReactQueryMutationHook('executeEquityContract', executeEquityContract)
